<template>
    <div class="date-picker-container uk-margin-small-bottom uk-margin-bottom@xs uk-margin-medium-bottom@m">
        <label class="uk-position-relative event-filter-label" @focusin="toggleIcon" @focusout="toggleIcon">
            <v-date-picker
                :locale="calLocale"
                mode="range"
                :value="selectedDate"
                @input="setDate"
                :theme="theme"
                :transition="'none'"
                :update-on-input="true"
                :attributes='calendarEvents'
                :is-inline="!isMobile"
                :popover='{visibility: "focus", placement: "bottom"}'
                :input-props='{ placeholder: $t("filters.date_range"), readonly: "readonly", class: "uk-form-small uk-input uk-text-medium" }'
                color="blue"
                class="date-picker"
                ref="calendar">
            </v-date-picker>
            <span uk-icon="chevron-down" v-if="isMobile" :class="{ 'uk-text-link uk-icon-rotate': isOpen }" class="uk-position-absolute uk-position-center-right uk-margin-xsmall-right uk-icon"></span>
        </label>
    </div>
</template>

<script>
    import DatePicker from 'v-calendar/lib/components/date-picker.umd'
    import { calendarTheme } from '../../static/calendar-theme.js'
    import { mapGetters } from "vuex";

    export default {
        name: "DatePicker",
        components: {
            'v-date-picker': DatePicker,
        },
        computed: {
            ...mapGetters([
                'calendarEvents',
                'selectedDate'
            ]),
            calLocale: function(){
                let params = {
                    id: this.locale,
                };

                if (this.locale === "ja"){
                    params.masks = {
                        title: 'YYYY年 MMMM'
                    }
                }
                return params;
            }
        },
        data() {
            return {
                theme: calendarTheme,
                isMobile: false,
                isOpen: false,
                isFromDatePicker: false,
                locale: window.events_data.locale
            }
        },
        methods: {
            formatDate(date) {
                const days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
                const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
                
                const day = days[date.getDay()];
                const month = months[date.getMonth()];
                const dayNum = date.getDate();
                const year = date.getFullYear();
                
                return `${day}, ${month} ${dayNum}, ${year}`;
            },
            setDate(value) {
                if (value) {
                    this.isFromDatePicker = true;
                    this.$store.dispatch('setDateQueryParams', value);
                } else {
                    // when deleting date
                    this.$store.dispatch('setDateQueryParams');
                }
            },
            onResize () {
                this.isMobile = window.innerWidth <= 1024;
            },
            toggleIcon() {
                this.isOpen = !this.isOpen;
            }
        },
        mounted () {
            this.onResize();
            window.addEventListener('resize', this.onResize, { passive: true })
        },
        beforeDestroy () {
            if (typeof window !== 'undefined') {
                window.removeEventListener('resize', this.onResize)
            }
        },
    }
</script>

<style lang="scss">
    @import "assets/src/scss/misc/mixins";
    @import "assets/src/scss/uikit-theme/variables";

    .uk-date-current {
        background: hsla(0, 0%, 89.4%, .5);
        color: #0b0b0b !important;
        display: flex;
        align-items: center;
        position: relative;
        padding: 10px 12px;

        border-radius: 4px;
        margin-bottom: 12px;

        @include max(m) {
            flex-direction: column;
        }

        &-text {
            font-size: 14px;
            font-weight: 400;
            position: absolute;
            left: 50%;
            transform: translateX(-50%);

            @include max(m) {
                position: relative;
                left: 0;
                transform: none;
            }
        }
    }

    .uk-date-indicator {
        background: hsla(0, 0%, 89.4%, .5);
        color: #0b0b0b !important;
        padding: 6px 12px !important;
        font-size: 14px;
    }

    .date-picker-container {
        @include max(m) {
            width: 100%;
        }
    }
    .date-picker {
        &.vc-container {
            --header-padding: 0 34px;
            --title-padding: 10px 12px;
            --arrow-container-height: 44px;
            --arrows-padding: 0;
            --weekday-padding: 5px 0;
            --weeks-padding: 5px 0;

            --day-min-height: 37px;
            --day-content-width: 30px;
            --day-content-height: 30px;
            --day-content-margin: 2px;

            --highlight-height: 30px;
            --highlight-width: 30px;
        }

        .vc-title-wrapper {
            width: 100%;
        }
        .vc-arrows-container {
            height: var(--arrow-container-height);
        }
        .vc-arrows {
            height: 36px;
            width: 36px;

            @include max(m) {
                height: auto;
                width: auto;
            }
        }
        .vc-weekday {
            line-height: 1.2;
            min-height: 30px;
            font-family: $global-monospace-font-family;
        }
        .vc-day-content {
            font-size: 10px !important;
            font-family: $global-monospace-font-family;
        }
        .vc-dayNotInMonth {
            color: rgba(#53718F, .5);
        }
        .vc-day-content:hover {
            border-radius: 3px !important;
            background-color: #81FBA5 !important;
            cursor: pointer;
        }
        .vc-highlight.uk-border-rounded-small {
            border-radius: 3px !important;
            margin-top: -3px;
        }
        .vc-highlight.vc-highlight-base-start.vc-border-highlight,
        .vc-highlight.vc-highlight-base-end.vc-border-highlight,
        .vc-highlight.vc-highlight-base-middle.vc-border-highlight {
            margin-top: -3px;
        }
        .vc-highlight.vc-highlight-base-start.vc-border-highlight,
        .vc-highlight.vc-highlight-base-end.vc-border-highlight {
            width: 100% !important;
           

        }
        .vc-highlight.vc-highlight-base-start.vc-border-highlight {
            border-radius: 8px 0 0 8px !important;
        }
        .vc-highlight.vc-highlight-base-end.vc-border-highlight {
            border-radius: 0 8px 8px 0 !important;
        }
        .vc-datePickerInput {
            box-sizing: border-box;
        }
        .vc-day-popover-row-indicator {
            span {
                background: #E1E8F0;
            }
        }
        .vc-datePickerInput::placeholder {
            font-size: 16px;
        }

        .vc-popover-content-wrapper {
            width: 100%;
            max-width: 327px;
            margin-top: 1px;
            overflow: hidden;
            z-index: 100;
            transform: translate3d(0px, 31px, 0px) !important;
            box-shadow: 0 0 8px 0 rgba(54, 77, 114, 0.08), 0 2px 4px 0 rgba(54, 77, 114, 0.18);
            border-radius: 8px;
            
            .vc-popover-content {
                width: 100%;
                margin-top: 0;
                background: white;
               
                color: #0B0B0B;

                &.direction-bottom {
                    margin-top: 0 !important;
                }

                .vc-popover-caret.direction-bottom {
                    display: none;
                }

               .vc-nav-title {
                    background-color: #E4E4E480 !important;
                    font-size: 14px !important;
                    color: #0B0B0B;
                    font-weight: 400;
                    padding: 3px 16px;
                    border-radius: 4px;
                }

                .vc-grid-cell {
                    span:not(.vc-nav-arrow) {
                        font-size: 12px;
                        font-weight: 400;
                        color: #0B0B0B;

                        &:hover {
                            background-color: #81FBA5;
                            border: none;
                            border-radius: 4px;
                            box-shadow: none;
                        }

                        &.vc-grid-focus {
                            border: none;
                            background-color: #E1E8F0;
                            box-shadow: none;
                            border-radius: 4px;
                        }
                    }

                    span.vc-nav-arrow {
                        color: #0B0B0B;
                        font-size: 14px;
                        font-weight: 400;

                        &:hover,
                        &:focus {
                            background-color: transparent;
                            border-color: transparent;
                            border-radius: 4px;
                            box-shadow: none;
                        }
                    }
                }
            }
            
            .vc-container {
                width: 100%;

                --day-min-height: 40px;
                --day-content-width: 40px;
                --day-content-height: 40px;
                --day-content-margin: 2px;
                --highlight-height: 40px;

                @media (max-width: 320px) {
                    --day-min-height: 32px;
                    --day-content-width: 32px;
                    --day-content-height: 32px;
                    --day-content-margin: 2px;
                    --highlight-height: 32px;
                }
            }
            .vc-title {
                padding: 10px 0;
                border-radius: 0;
            }
            .vc-header {
                padding: 0;
            }
        }

        .vc-highlight-base-middle {
            background-color: transparent;
        }
    }
    .vc-bg-blue {
        background-color: #a6b0ff;
        color: #fff;
    }
    // Not sure where this .vc-bg-gray class is coming from, closest example 
    // is in datarobot6/assets/src/js/vue/events/static/calendar-theme.js 
    // Wherever it is, it's green now.
    .vc-bg-gray {
        background-color: #E1E8F0; 
    }
    .vc-text-contrast-blue {
        color: #fff;
    }
    .vc-highlights + .vc-text-contrast-blue {
        color: #23232D;
    }
    .vc-border-highlight {
        border: 2px solid #a6b0ff;
        z-index: 1;
    }

    .vc-highlights .vc-highlight.highlightStartEndClass.bgAccentHigh.vc-bg-blue {
        background-color: unset;
        border: 2px solid #a6b0ff;
    }
    .is-today .vc-highlights .vc-highlight.highlightStartEndClass.bgAccentHigh.vc-bg-blue {
        background-color: #a6b0ff;
        border: none;
    }
    .is-today .vc-highlights + .vc-text-contrast-blue,
    .is-today .vc-highlights + .contentAccent {
        color: #0B0B0B;
    }
</style>

